import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import {
  View,
} from '@uncinc/react-drupal-core';

import {
  VideoPopup,
  WysiwygField,
  Container,
  Divider,
  Breadcrumbs,
} from '../../../../components';

import './style.scss';

const NodeVideoSelectionFull = ({ id, entity, className }) => {
  const classes = classNames(className);
  return (
    <article typeof="schema:WebPage" className={classes}>
      <Container>
        <div>
          <Breadcrumbs />
          {entity.getIn(['body', 0, 'processed']) ? (
            <div className="row">
              <div className="col-md-12">
                <h1 className="node--video-selection--title page-header">{entity.getIn(['title', 0, 'value'])}</h1>
                <WysiwygField
                  property="schema:text"
                  className="node--video-selection--body"
                  html={entity.getIn(['body', 0, 'processed'], '')}
                />
              </div>
            </div>
          ) : null}
        </div>
        {entity.get('field_videos') ? (
          <div className="node--video-selection--paragraphs-wrapper row">
            {entity.get('field_videos', List()).map((referencedEntity) => {
              const videoId = referencedEntity.get('target_id');
              const language = referencedEntity.getIn(['entity', 'langcode', 0, 'value']);
              const thumbnail = referencedEntity.getIn(['styles', 'teaser_image']);
              const title = referencedEntity.get('title');
              const embedUrl = referencedEntity.get('embed');

              return (
                <VideoPopup
                  key={`media:${videoId}:${language}`}
                  className="col-md-4 col-xs-12 mb-6"
                  thumbnail={thumbnail}
                  title={title}
                  embedUrl={embedUrl}
                />
              );
            })}
          </div>
        ) : null}
      </Container>
      <Divider className="related-divider" />
      <View id="related_series" display="block_1" />
    </article>
  );
};

export default NodeVideoSelectionFull;
